
    /* --- Offer Timer --- */
    function updateOfferTimer() {
        var now = new Date(), end = new Date();
        end.setHours(23, 59, 59, 999);
        var d = end - now;
        var h = String(Math.floor(d / 3600000)).padStart(2, '0');
        var m = String(Math.floor((d % 3600000) / 60000)).padStart(2, '0');
        var s = String(Math.floor((d % 60000) / 1000)).padStart(2, '0');
        var el = document.getElementById('offer-timer');
        if (el) el.textContent = h + ':' + m + ':' + s;
    }
    updateOfferTimer();
    setInterval(updateOfferTimer, 1000);

    /* --- IntersectionObserver --- */
    var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('active'); });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    document.querySelectorAll('.reveal, .reveal-right').forEach(function (el) { obs.observe(el); });

    /* --- Gallery Slider --- */
    var sliderImages = document.querySelectorAll('#slider-track img');
    var gallerySlides = document.querySelectorAll('#slider-track > div');
    var totalSlides = (typeof wp_total_images !== 'undefined' && wp_total_images > 0) ? wp_total_images : (window.product_data && window.product_data.images ? window.product_data.images.length : gallerySlides.length);
    var track = document.getElementById('slider-track');
    var dots = document.querySelectorAll('.gallery-dot');
    var prevBtn = document.getElementById('prev-btn');
    var nextBtn = document.getElementById('next-btn');
    var currentSlide = 0;

    function goToSlide(index) {
        if (index < 0) index = totalSlides - 1;
        if (index >= totalSlides) index = 0;
        currentSlide = index;
        if (track) track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
        dots.forEach(function (dot, i) {
            dot.classList.toggle('bg-black-950', i === currentSlide);
            dot.classList.toggle('bg-silver-300', i !== currentSlide);
        });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(currentSlide - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(currentSlide + 1); });
    dots.forEach(function (dot, i) { dot.addEventListener('click', function () { goToSlide(i); }); });

    var touchStartX = 0;
    if (track) {
        track.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].screenX; }, { passive: true });
        track.addEventListener('touchend', function (e) {
            var diff = touchStartX - e.changedTouches[0].screenX;
            if (diff > 50) goToSlide(currentSlide + 1);
            if (diff < -50) goToSlide(currentSlide - 1);
        }, { passive: true });
    }

    /* --- Gallery Lightbox --- */
    var lightbox = document.getElementById('lightbox');
    var lightboxImg = document.getElementById('lightbox-img');
    var lightboxCounter = document.getElementById('lightbox-counter');
    var lightboxDots = document.querySelectorAll('.lb-dot');
    var lightboxClose = document.getElementById('lightbox-close');
    var lightboxPrev = document.getElementById('lightbox-prev');
    var lightboxNext = document.getElementById('lightbox-next');
    var lightboxIndex = 0;

    function openLightbox(index) {
        lightboxIndex = index;
        updateLightbox();
        if (lightbox) lightbox.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
        if (lightbox) lightbox.classList.add('hidden');
        document.body.style.overflow = '';
    }

    function updateLightbox() {
        if (lightboxImg && sliderImages[lightboxIndex]) lightboxImg.src = sliderImages[lightboxIndex].src;
        if (lightboxCounter) lightboxCounter.textContent = (lightboxIndex + 1) + ' / ' + totalSlides;
        lightboxDots.forEach(function (dot, i) {
            dot.classList.toggle('bg-white', i === lightboxIndex);
            dot.classList.toggle('bg-white/30', i !== lightboxIndex);
        });
    }

    function lightboxNav(dir) {
        lightboxIndex += dir;
        if (lightboxIndex < 0) lightboxIndex = totalSlides - 1;
        if (lightboxIndex >= totalSlides) lightboxIndex = 0;
        updateLightbox();
    }

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { lightboxNav(-1); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { lightboxNav(1); });
    lightboxDots.forEach(function (dot, i) { dot.addEventListener('click', function () { lightboxIndex = i; updateLightbox(); }); });
    if (lightbox) lightbox.addEventListener('click', function (e) { if (e.target === lightbox) closeLightbox(); });

    var reviewImages = document.querySelectorAll('[onclick^="openReviewLightbox"]');
    var reviewLightbox = document.getElementById('review-lightbox');
    var reviewLightboxImg = document.getElementById('review-lightbox-img');
    var reviewCounter = document.getElementById('review-counter');
    var reviewUser = document.getElementById('review-user');
    var reviewStars = document.getElementById('review-stars');
    var currentReview = 0;
    var totalReviews = reviewImages.length;

    function openReviewLightbox(index) {
        currentReview = index;
        updateReviewLightbox();
        if (reviewLightbox) reviewLightbox.classList.remove('hidden');
        document.body.style.overflow = 'hidden';
    }

    function closeReviewLightbox() {
        if (reviewLightbox) reviewLightbox.classList.add('hidden');
        document.body.style.overflow = '';
    }

    function updateReviewLightbox() {
        var img = reviewImages[currentReview] ? reviewImages[currentReview].querySelector('img') : null;
        var user = reviewImages[currentReview] ? reviewImages[currentReview].dataset.user : '';
        var rating = reviewImages[currentReview] ? parseInt(reviewImages[currentReview].dataset.rating) : 5;
        if (reviewLightboxImg && img) reviewLightboxImg.src = img.src.replace('w=400&h=400', 'w=800&h=800');
        if (reviewCounter) reviewCounter.textContent = (currentReview + 1) + ' / ' + totalReviews;
        if (reviewUser) reviewUser.textContent = user;
        if (reviewStars) {
            reviewStars.innerHTML = '';
            for (var i = 0; i < 5; i++) {
                var star = document.createElement('i');
                star.className = 'fas fa-star ' + (i < rating ? 'text-amber-400' : 'text-white/20');
                reviewStars.appendChild(star);
            }
        }
    }

    function reviewLightboxNav(dir) {
        currentReview += dir;
        if (currentReview < 0) currentReview = totalReviews - 1;
        if (currentReview >= totalReviews) currentReview = 0;
        updateReviewLightbox();
    }

    if (reviewLightbox) reviewLightbox.addEventListener('click', function (e) { if (e.target === reviewLightbox) closeReviewLightbox(); });

    document.addEventListener('keydown', function (e) {
        if (lightbox && !lightbox.classList.contains('hidden')) {
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') lightboxNav(-1);
            if (e.key === 'ArrowRight') lightboxNav(1);
            return;
        }
        if (reviewLightbox && !reviewLightbox.classList.contains('hidden')) {
            if (e.key === 'Escape') closeReviewLightbox();
            if (e.key === 'ArrowLeft') reviewLightboxNav(-1);
            if (e.key === 'ArrowRight') reviewLightboxNav(1);
            return;
        }
    });

    function toggleFaq(btn) {
        var item = btn.parentElement;
        var content = item.querySelector('.faq-content');
        var allItems = document.querySelectorAll('.faq-item');
        allItems.forEach(function (i) {
            if (i !== item) {
                i.classList.remove('active');
                var c = i.querySelector('.faq-content');
                if (c) c.classList.add('hidden');
            }
        });
        item.classList.toggle('active');
        if (content) content.classList.toggle('hidden');
    }